export const sortFields = [
	'id',
	'name',
	'takeoffTypeRef',
	'organizationId',
	'measurementTypeRef',
	'ingredients',

	'createdAt',
	'updatedAt',
] as const;
